import { UI } from '@genial/components';
import React from 'react';

interface SubscriptionSolicitationActionProps {
  title: string;
  onPress: () => void;
}

export const SubscriptionSolicitationAction: React.FC<SubscriptionSolicitationActionProps> = ({
  title,
  onPress,
}) => {
  return <UI.Button onPress={onPress}>{title}</UI.Button>;
};
